// extracted by mini-css-extract-plugin
export default {"container":"PreLoader_container__+RaTd","logo":"PreLoader_logo__eMMYo","name":"PreLoader_name__msDeA"};